var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 198,
    viewBox: "0 0 171 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.435 141.536C157.867 130.086 145.042 120.948 130.769 114.698C116.495 108.448 101.082 105.221 85.5 105.221C69.9181 105.221 54.505 108.448 40.2314 114.698C25.9579 120.948 13.1331 130.086 2.565 141.536C0.928039 143.337 0.0145041 145.679 0 148.113V187.574C0.0345844 190.168 1.08922 192.644 2.9356 194.465C4.78198 196.287 7.27155 197.309 9.86538 197.308H161.135C163.751 197.308 166.26 196.269 168.11 194.419C169.961 192.569 171 190.059 171 187.443V147.981C170.953 145.593 170.042 143.303 168.435 141.536Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5004 92.0769C110.927 92.0769 131.539 71.4648 131.539 46.0385C131.539 20.6121 110.927 0 85.5004 0C60.074 0 39.4619 20.6121 39.4619 46.0385C39.4619 71.4648 60.074 92.0769 85.5004 92.0769Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcn);
export default __webpack_public_path__ + "static/media/profile-icn.7f6a23f31f94d7a2c9c9526f7a3423d4.svg";
export { ForwardRef as ReactComponent };